import { api } from "@/lib/axios";
import type { ApiResponse } from "@/features/permission";
import type {
  DeleteSystemRoleRequest,
  RoleImpact,
  RolePermissionMapping,
  SetPermissionsRequest,
  SystemRole,
  UpsertSystemRoleRequest,
} from "../types/systemRole.types";

export const listSystemRoles = async (): Promise<SystemRole[]> => {
  const { data } = await api.get<ApiResponse<SystemRole[]>>(
    "/api/SystemRole/List",
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const getSystemRole = async (roleGuid: string): Promise<SystemRole> => {
  const { data } = await api.get<ApiResponse<SystemRole>>(
    `/api/SystemRole/Role/${roleGuid}`,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const getSystemRolePermissions = async (
  roleGuid: string,
): Promise<RolePermissionMapping[]> => {
  const { data } = await api.get<ApiResponse<RolePermissionMapping[]>>(
    `/api/SystemRole/Role/${roleGuid}/Permissions`,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const getSystemRoleImpact = async (
  roleGuid: string,
): Promise<RoleImpact> => {
  const { data } = await api.get<ApiResponse<RoleImpact>>(
    `/api/SystemRole/Role/${roleGuid}/Impact`,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const upsertSystemRole = async (
  req: UpsertSystemRoleRequest,
): Promise<SystemRole> => {
  const { data } = await api.post<ApiResponse<SystemRole>>(
    "/api/SystemRole/Upsert",
    req,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const setSystemRolePermissions = async (
  req: SetPermissionsRequest,
): Promise<void> => {
  const { data } = await api.post<ApiResponse<null>>(
    "/api/SystemRole/SetPermissions",
    req,
  );
  if (data.code !== 200) throw new Error(data.message);
};

export const deleteSystemRole = async (
  req: DeleteSystemRoleRequest,
): Promise<RoleImpact> => {
  const { data } = await api.post<ApiResponse<RoleImpact>>(
    "/api/SystemRole/Delete",
    req,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};
